// extracted by mini-css-extract-plugin
export default {"hideScrollbar":"d529e558","shrinkButtonContainer":"d9a39037","shrinkButton":"b9c690e8"};